import { api } from './api';

const getCurrentUser = async (params = {}) => {
    const response = await api({
        url: '/Users/getCurrentUser',
        method: 'GET',
        id: 'Users-getCurrentUser',
        params,
        cache: {
            ttl: 8 * 60 * 60 * 1000
        },
    });
    return response.data;
};

const currentUserUpdate = async (data) => {
    const response = await api({
        url: '/Users',
        method: 'PUT',
        data,
    });
    return response.data;
};

const reGmsSendOtp = async (data) => {
    const response = await api({
        url: '/Users/SendGsmOtp',
        method: 'POST',
        data,
    });
    return response.data;
};

const reConfirmGmsOtp = async (data) => {
    const response = await api({
        url: '/Users/ConfirmGsmOtp',
        method: 'POST',
        data,
    });
    return response.data;
};

const reEmailSendOtp = async (data) => {
    const response = await api({
        url: '/Users/EmailSendOtp',
        method: 'POST',
        data,
    });
    return response.data;
};

const reConfirmEmailOtp = async (data) => {
    const response = await api({
        url: '/Users/ConfirmEmailOtp',
        method: 'POST',
        data,
    });
    return response.data;
};

const profileServices = {
  getCurrentUser,
  currentUserUpdate,
  reGmsSendOtp,
  reConfirmGmsOtp,
  reEmailSendOtp,
  reConfirmEmailOtp,
};

export default profileServices;
